import React, {useEffect, useState} from "react";
import { Marker } from "react-google-maps";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import MobileBoxIcon from "assets/svg/mobile-box-car.svg";
// import MobileBoxIcon from "assets/svg/water-drone.svg";
import { MeasurementUnit } from "./Measurement";
import { useDevicesContext, useMapContext, useDemoReplaysContext, useMobileDataContext } from "../UAVMapContainer";
import map from "lodash/map";
import Card from "components/Card/Card";
import { pmColor, tempColor } from "./color_utils";
import { lightBlue } from "@material-ui/core/colors";
import { scaleIconSize } from "./utils";

const InfoBoxOptions = {
  pixelOffset: { width: -60, height: -210 },
  boxStyle: {
    padding: "0px 0px 0px 0px",
  },
  closeBoxURL: "",
  // infoBoxClearance: { width: 1, height: 1 },
  isHidden: false,
  enableEventPropagation: true
};

const CustomCardStyle = {
  background: "rgba(0, 27, 45, 0.7)",
  marginTop: 0,
  padding: 5,
  width: 140,
  color: "white",
  textAlign: "center"
};

export default function MobileBoxMarker() {

  const [showStationInfobox, setShowStationInfobox] = useState({ "MOBILE_1": true });

  const { state, dispatch } = useMobileDataContext();
  const { idx } = state;

  const { state: mapState } = useMapContext();
  const { zoom } = mapState;
  const { height, width } = scaleIconSize(zoom);

  const { state: demoState } = useDemoReplaysContext();
  const isDemoRunning = demoState?.activeMission;
  const {simulationData} = demoState;
  useEffect(() => setShowStationInfobox({"MOBILE_1": !!simulationData}), [simulationData]);

  const { state: devicesState } = useDevicesContext();
  const { onlineDevices } = devicesState;

  const datapointsPerDevice = state.mobileData;

  return map(datapointsPerDevice, (datapoints, serialNo) => {
    if ((isDemoRunning && !serialNo.includes("DEMO")) ||
      !isDemoRunning && serialNo.includes("DEMO")
    ) {
      return null;
    }
    const data = datapoints[datapoints.length - 1];

    return onlineDevices.includes(serialNo) ? <Marker
      key={serialNo}
      position={{ lat: data.lat, lng: data.lng }}
      icon={{ url: MobileBoxIcon, scaledSize: { height, width } }}
      onClick={() => setShowStationInfobox({ ...showStationInfobox, [serialNo]: !showStationInfobox[serialNo] })}
    >
      {showStationInfobox[serialNo] &&
      <InfoBox options={InfoBoxOptions}>
        <Card style={CustomCardStyle}>
          {serialNo === "MOBILE_1" || serialNo === "DEMO_MOBILE_1" ? <b>Pojazd #1</b> : <div>#{serialNo}</div>}

          {/*<div>{moment(data.t).format("hh:mm:ss")}</div>*/}
          <br/>

          <div>
            PM10: <span style={{ color: pmColor(data.PM10 || 10) }}>
                  {Math.round(data.PM10) || 10} [{MeasurementUnit.PM10}]
                </span>
          </div>
          <div>
            PM2.5: <span style={{ color: pmColor(data.PM10 || 10) }}>
                  {Math.round(data.PM25) || 8} [{MeasurementUnit.PM25}]
                </span>
          </div>
          <div>
            Temp: <span style={{ color: tempColor(data.temp || 20) }}>
                  {Math.round(data.temp) || 20.0} [{MeasurementUnit.temp}]
                </span>
          </div>
          <div>
            RH: <span style={{ color: lightBlue[300] }}>
                  {Math.round(data.RH) || 60.0} [{MeasurementUnit.RH}]
                </span>
          </div>
        </Card>
      </InfoBox>}
    </Marker> : null;
  });
}
